import { useTranslator } from "components/Translator"
import { DescriptionsList, DescriptionItem } from "components/DescriptionsList"
import { AccordionSection } from "components/Accordion"
import isNil from "lodash/isNil"

export const BoatComfort = (props) => {
  const { boat } = props
  const translator = useTranslator()

  return boat ? (
    <AccordionSection
      label={translator.trans("BoatComfort.title", null, "components")}
    >
      <DescriptionsList>
        <DescriptionItem
          label={translator.trans(
            "BoatComfort.capacityComfort",
            null,
            "components",
          )}
          value={!isNil(boat.capacityComfort) ? boat.capacityComfort : null}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatComfort.capacityMax",
            null,
            "components",
          )}
          value={!isNil(boat.capacityMax) ? boat.capacityMax : null}
        />
        <DescriptionItem
          label={translator.trans("BoatComfort.nbCabins", null, "components")}
          value={boat.nbCabins}
        />
        <DescriptionItem
          label={translator.trans("BoatComfort.nbBeds", null, "components")}
          value={boat.nbBeds}
        />
        <DescriptionItem
          label={translator.trans("BoatComfort.nbToilets", null, "components")}
          value={boat.nbToilets}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatComfort.marineToilet",
            null,
            "components",
          )}
          value={boat.marineToilet}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatComfort.showerCabin",
            null,
            "components",
          )}
          value={boat.showerCabin}
        />
        <DescriptionItem
          label={translator.trans("BoatComfort.hotWater", null, "components")}
          value={boat.hotWater}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatComfort.freshWaterCapacity",
            null,
            "components",
          )}
          value={boat.freshWaterCapacity}
        />
        <DescriptionItem
          label={translator.trans("BoatComfort.watermaker", null, "components")}
          value={boat.watermaker}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatComfort.kitchenEquipments",
            null,
            "components",
          )}
          value={boat.kitchenEquipments}
          id="boat-kitchen-equipments"
        />
      </DescriptionsList>
    </AccordionSection>
  ) : null
}
